module.exports = __webpack_public_path__ + "img/wallet_03_marginx.c06cd508.png";